export default {
	'Search': 'Search',
	'Back to search': 'Back to search',
	'Check in': 'Check in',
	'Check Out': 'Check Out',
	'Terms and Conditions': 'Terms and Conditions',
	'Privacy Policy': 'Privacy Policy',
	'Book a co-living space': 'Book a co-living space',
	'Minimum duration': 'Minimum duration',
	'Maximum duration': 'Maximum duration',
	'day': 'day',
	'Days': 'Days',
	'week': 'week',
	'weeks': 'weeks',
	'month': 'month',
	'months': 'months',
	'January': 'January',
	'February': 'February',
	'March': 'March',
	'April': 'April',
	'May': 'May',
	'June': 'June',
	'July': 'July',
	'August': 'August',
	'September': 'September',
	'October': 'October',
	'November': 'November',
	'December': 'December',
	'Minimum stay is': 'Minimum stay is',
	'Description': 'Description',
	'Free cancellation': 'Free cancellation',
	'Location': 'Location',
	'Getting here': 'Getting here',
	'Add dates for prices': 'Add dates for prices',
	'Refine your booking': 'Refine your booking',
	'Total': 'Total',
	'Inquire': 'Inquire',
	'Book Now': 'Book Now',
	'Room': 'Room',
	'Rooms': 'Rooms',
	'Request for availability': 'Request for availability',
	'Extras and upgrades': 'Extras and upgrades',
	'Extras': 'Extras',
	'unit': 'unit',
	'remove': 'remove',
	'Booking summary': 'Booking summary',
	'Checkout': 'Checkout',
	'Proceed to checkout': 'Proceed to checkout',
	'Need more rooms?': 'Need more rooms?',
	'Add Room': 'Add Room',
	'We will hold your reservation until you add all rooms you need.': 'We will hold your reservation until you add all rooms you need.',
	'person': 'person',
	'Amenities': 'Amenities',
	'City tax': 'City tax',
	'Contact information': 'Contact information',
	'Services': 'Services',
	'Name': 'Name',
	'Last name': 'Last name',
	'Email': 'Email',
	'Your phone': 'Your phone',
	'Country': 'Country',
	'Date of birth': 'Date of birth',
	'Company': 'Company',
	'Company code': 'Company code',
	'Company address': 'Company address',
	'Company VAT code': 'Company VAT code',
	'Have a discount code?': 'Have a discount code?',
	'Discount code': 'Discount code',
	'Apply': 'Apply',
	'I accept': 'I accept',
	'and': 'and',
	'I agree to get marketing info.': 'I agree to get marketing info.',
	'I agree to get marketing info. I may unsubscribe anytime.': 'I agree to get marketing info. I may unsubscribe anytime.',
	'Pay': 'Pay',
	'Booking details': 'Booking details',
	'VAT': 'VAT',
	'Total (taxes incl.)': 'Total (taxes incl.)',
	'Required': 'Required',
	'It appears that this discount code is invalid.': 'It appears that this discount code is invalid.',
	'Must be an email': 'Must be an email',
	'Discount code applied': 'Discount code applied',
	'It is not available during selected dates': 'It is not available during selected dates',
	'Request': 'Request',
	'Failed reservation': 'Failed reservation',
	'There was a problem and we were not able to complete your reservation order. Possible reasons why order failed are,': 'There was a problem and we were not able to complete your reservation order. Possible reasons why order failed are,',
	'a billing error caused by your bank': 'a billing error caused by your bank',
	'insufficient credit on your account': 'insufficient credit on your account',
	'your credit card is expired': 'your credit card is expired',
	'booking was cancelled or expired': 'booking was cancelled or expired',
	'Total paid': 'Total paid',
	'Total due (taxes incl.)': 'Total due (taxes incl.)',
	'Check-in': 'Check-in',
	'Check-out': 'Check-out',
	'Minimum stay duration': 'Minimum stay duration',
	'Maximum stay duration': 'Maximum stay duration',
	'It seems that your booking has expired, please, start over.': 'It seems that your booking has expired, please, start over.',
	'InvalidId': 'InvalidId',
	'BookingProductEmptyFromToDates': 'BookingProductEmptyFromToDates',
	'InvalidBooking': 'InvalidBooking',
	'BookingExpired': 'BookingExpired',
	'BookingHasUnavailableProducts': 'BookingHasUnavailableProducts',
	'BookingAlreadyCheckedOut': 'BookingAlreadyCheckedOut',
	'BookingAlreadyDeleted': 'BookingAlreadyDeleted',
	'BookingExpectedAllBookingProductsToHaveReservation': 'BookingExpectedAllBookingProductsToHaveReservation',
	'ColivingBookingCheckoutMissingDeliveryMethod': 'ColivingBookingCheckoutMissingDeliveryMethod',
	'BookingOneOrMoreProductsUnavailable': 'BookingOneOrMoreProductsUnavailable',
	'DurationIsTooShort': 'DurationIsTooShort',
	'DurationIsTooLong': 'DurationIsTooLong',
	'DurationIsNegativeOrZero': 'DurationIsNegativeOrZero',
	'InvalidDate': 'InvalidDate',
	'DuplicateOrder': 'DuplicateOrder',
	'BookingNothingToInvoice': 'BookingNothingToInvoice',
	'InvalidAvailabilityRange': 'InvalidAvailabilityRange',
	'InvalidAvailabilityRangeExceedsTwoCalendarMonths': 'InvalidAvailabilityRangeExceedsTwoCalendarMonths',
	'MinDurationMustBe1day': 'MinDurationMustBe1day',
	'BookingShouldHaveAtLeastOneBookableProduct': 'BookingShouldHaveAtLeastOneBookableProduct',
	'PayseraIntegrationDisabled': 'PayseraIntegrationDisabled',
	'CheckoutCreationFailed': 'CheckoutCreationFailed',
	'CheckoutPriceCalculationFailed': 'CheckoutPriceCalculationFailed',
	'NotFound': 'NotFound',
	'ValidationError': 'ValidationError',
	'Hello there': 'Hello there',
	'Your booking has been updated. Please, review the newly added items and proceed with a follow-up payment.': 'Your booking has been updated. Please, review the newly added items and proceed with a follow-up payment.',
	'Your booking reservation': 'Your booking reservation',
	'Customer': 'Customer',
	'Your order online': 'Your order online',
	'Added items': 'Added items',
	'Beds': 'Beds',
	'Quantity': 'Quantity',
	'Night': 'Night',
	'Book again': 'Book again',
	'Booking updated': 'Booking updated',
	'Thanks for booking.': 'Thanks for booking.',
	'Booking confirmation': 'Booking confirmation',
	'Click here to View Order online': 'Click here to View Order online',
	'Discount': 'Discount',
	'Submit': 'Submit',
	'Cancel': 'Cancel',
	'Please fill contact form': 'Please fill contact form',
	'Add': 'Add',
	'Thank you, your inquiry has been received and is being processed. Someone will contact you as soon as possible!': 'Thank you, your inquiry has been received and is being processed. Someone will contact you as soon as possible!',
	'Back to main page after': 'Back to main page after',
	'seconds': 'seconds',
	'Upon arrival': 'Upon arrival',
	'Price (taxes incl.)': 'Price (taxes incl.)',
	'room': 'room',
	'bed': 'bed',
	'Nights': 'Nights',
	'nights': 'nights',
	'We are now accepting reservations': 'We are now accepting reservations',
};
